import Dateprint, { dateprintFormat, dateprintRelative } from '@/utils/dateprint';

export default {
  install(Vue) {
    const dateprint = Dateprint;

    Vue.filter('dp', dateprintFormat);
    Vue.filter('dp:from-now', (val) => dateprintRelative(val, new Date()));
    Vue.dp = dateprint;
    Vue.prototype.$dp = dateprint;
  },
};
